import { render, staticRenderFns } from "./redpacketRechargeList.vue?vue&type=template&id=48d5a723&scoped=true&"
import script from "./redpacketRechargeList.vue?vue&type=script&lang=js&"
export * from "./redpacketRechargeList.vue?vue&type=script&lang=js&"
import style0 from "./redpacketRechargeList.vue?vue&type=style&index=0&id=48d5a723&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d5a723",
  null
  
)

export default component.exports